// removed by extract-text-webpack-plugin
module.exports = {"container":"EblDnOZiMaeyK-JNTBvg5","title":"_73VglhwxcnV6H7YZ5fBeN"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Preparation/SSSellNoteAdvance/AdvanceForm/Total/styles.css
// module id = 3300
// module chunks = 0